import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary, PortalMetadata, ThemeProvider } from '@command-center/ui-system';
import { App } from './App';
import { AuthGate } from './auth/AuthGate';
import { AuthProvider } from './auth/AuthProvider';
import { queryClient } from './lib/queryClient';
import { getBranding } from './platform/branding';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

const brandingForTheme = getBranding();

createRoot(root).render(
  <StrictMode>
    <ThemeProvider
      defaultTheme="light"
      storageKey="cascade-theme"
      colors={brandingForTheme.colors}
    >
      <PortalMetadata branding={brandingForTheme} />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <AuthGate>
              <ErrorBoundary title="The app crashed.">
                <App />
              </ErrorBoundary>
            </AuthGate>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
